/**
 * Make CSS :active states engage immediately on iOS.
 *
 * Without any touchstart listener on the document, iOS WebKit delays applying :active
 * (~300ms) while it decides whether the touch is a scroll — press feedback reads as dead.
 * A document-level touchstart listener (even a no-op) switches WebKit to applying :active
 * on touch. Passive, so scrolling performance is untouched; harmless on other platforms.
 *
 * Call once from each bundle entry whose page carries :active press feedback.
 */
export function enableInstantActiveStates(providedDocument = document) {
    providedDocument.addEventListener('touchstart', () => {}, { passive: true });
}
